import React from 'react';
import { CardContainer } from './styles';

const Card = ({
  className = '',
  bgColor, 
  children
}) => {
  return (
    <CardContainer
      bgColor={bgColor}
      className={`${className} card-shadow`}
    >
      { children }
    </CardContainer>
  );
}

export default Card;
